import axios from '../../common/axios.js'
import Modale from '../../common/ui/modale.vue'
import moment from 'moment'
import CustomInput from '../../common/forms/Input.vue'

export default {
	data(){
		return {
			erreur: false,
			encours: false,
			succes: false,
			nom: '',
			pardefaut: false,
			recherche_exclue: null,
			combiner: false
		}
	},
	props:{
		mode:{
			default: 'modale' // modale | update
		},
		picto:{
			default: true
		},
		close:{
			default: true
		}
	},
	created(){

	},
	methods:{
		save(){
			var self = this;
			self.$emit('save_start')
			let update = this.mode == 'update';
			if(!update && self.nom == ''){
				self.erreur  = this.$t('save_search_erreur');
				self.encours = false;
				self.encours = false;
			}else{
				self.erreur  = false;
				self.encours = true;
				self.succes  = false;

				let recherche = {}

				if(!update){
					recherche = {
						nom: self.nom,
						recherche: self.$store.state.filters.filters,
						pardefaut: self.pardefaut,
						layers: self.$store.getters.getLayersToSave
					}
    				if(this.combiner && this.recherche_exclue) recherche.recherche.substract_search = this.recherche_exclue.nom
				}else{
					recherche = _.cloneDeep(this.$store.state.ui.recherche)
					recherche.recherche = self.$store.state.filters.filters
					recherche.layers    = self.$store.getters.getLayersToSave
					recherche.update    = true
				}

				axios({
					method: 'post',
					url: 'api=webinex/saveUserSearch', 
					data: recherche, 
					headers: {'Content-Type': 'application/json'}
				})
				.then(function (response) {
					if(response.status == 200){
						self.encours = false;
						self.succes  = true;
						if(!update){
							recherche.pardefaut                  = self.pardefaut
							recherche.recherche.substract_search = self.combiner && self.recherche_exclue ? self.recherche_exclue.nom : null
							self.$store.dispatch('add_recherche', recherche);
						}else{
							recherche.updated = moment(Date.now()).format('YYYY-MM-DD HH:mm:ss')
							self.$store.dispatch('update_recherche', recherche);
						}
						// setTimeout(function(){
							self.$store.commit('UI_SET_RECHERCHE_ID', recherche.nom)
							self.$store.dispatch('setSaveSearch', recherche)
						// },50)
						setTimeout(function(){
							self.$store.dispatch('close_modal', 'save_search')
						},2000);
					}else{
						self.encours = false;
						self.succes  = false;
						self.erreur  = response.data;
					}
					self.$emit('save_end')
				})
				.catch(function (error) {
					self.$emit('save_end')
				})
			}
		}
	},
	computed:{
		recherches(){
			let recherches = _.cloneDeep(this.$store.state.user.recherches)
			recherches.forEach(function(recherche, index){
				if(recherche.nom == "__last__") recherches = _.without(recherches, recherche)
			})
			return recherches
		}
	},
	components:{
		Modale,
		CustomInput
	}
}
